<div class="modal-content templateUploader">
  <!--  TITLE HEADER-->
  <div class="modal-header">
    <button
      type="button"
      class="close"
      (click)="closeDialog()"
      aria-hidden="true"
    >
      ×
    </button>
    <h3 id="myModalLabel">Users Feature Edition</h3>
  </div>

  <!--  BODY -->
  <div class="modal-body row">
    <div
      class="col-md-12"
      *ngIf="mappedFeatures$ | async as features; else showLoading"
    >
      <p-table #dt [value]="features" [columns]="cols" class="custom-table">
        <ng-template pTemplate="caption">
          <div style="text-align: left">
            <i
              class="fa fa-search"
              style="margin: 4px 4px 0 0; color: black"
              aria-hidden="true"
            ></i>
            <input
              type="text"
              pInputText
              size="50"
              placeholder="Search Toggle"
              (input)="dt.filterGlobal($event.target.value, 'contains')"
              style="width: auto"
            />
          </div>
        </ng-template>
        <ng-template pTemplate="colgroup" let-columns>
          <colgroup>
            <col *ngFor="let col of columns" [style.width]="col.width" />
          </colgroup>
        </ng-template>
        <ng-template pTemplate="header" let-columns>
          <tr>
            <th *ngFor="let col of columns">{{ col.header }}</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-feature>
          <tr>
            <td>{{ feature.name }}</td>
            <td>{{ feature.key }}</td>
            <td>{{ feature.id }}</td>
            <td>
              <feature-toggle
                [value]="feature.status"
                (onChange)="onToggleFeature($event, feature)"
              ></feature-toggle>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
    <ng-template #showLoading>
      <div class="col-md-12" style="text-align: center" >
        <img style="margin-top: 20px;
                    margin-bottom: 20px;"
             src="/img/loading.gif"/>
      </div>
    </ng-template>
  </div>

  <!--  FOOTER-->
  <div class="modal-footer">
    <button class="btn btn-primary" aria-hidden="true" (click)="update()">
      Update
    </button>
    <button class="btn btn-default" aria-hidden="true" (click)="closeDialog()">
      Close
    </button>
  </div>
</div>
